//given a query string from a URL, ex "a=1&b=2&c=testing"
//returns a key--string-value object of the query parameters, ex {a:"1", b:"2", c:"testing"}
//if you want to get a value as a number, you'll have to manualy parseInt or parseFloat after the query object is returned
export default function parseUrlQuery(str) {
  const query = {}; //initialize an empty query object


  const params = str.split("&"); //split the str by the & symbols into an array of parameters
  for(let i=0; i<params.length; ++i) {
    const keyValue = params[i].split("="); //split the key and value by the = symbol
    if(keyValue.length === 2) { //if there is exactly one key and one value
      query[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]).trim(); //decode the URL value into regular js string value
    }
  }

  return query;
}
